import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import ExpenseForm from "@/components/feature/ExpenseForm";
import { categoryApi } from "@/services/api";
import type { Category } from "@/models/types";

export default function NewExpense() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await categoryApi.list();
        setCategories(data);
      } catch (error) {
        console.error("Error cargando categorías:", error);
      } finally {
        setLoading(false);
      }
    };
    loadCategories();
  }, []);

  return (
    <AppLayout>
      <div className="max-w-2xl mx-auto">
        <Link
          to="/gastos"
          className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-foreground-900 mb-4 cursor-pointer"
        >
          <i className="ri-arrow-left-line" /> Volver a gastos
        </Link>
        <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
          <h2 className="text-lg font-heading font-semibold text-foreground-950 mb-1">
            Nuevo gasto
          </h2>
          <p className="text-sm text-foreground-500 mb-6">
            Registra tu compra e introduce manualmente el importe.
          </p>
          {loading ? (
            <div className="flex justify-center py-8">
              <i className="ri-loader-4-line animate-spin text-2xl text-primary-500" />
            </div>
          ) : (
            <ExpenseForm categories={categories} />
          )}
        </div>
      </div>
    </AppLayout>
  );
}